module.exports = __webpack_public_path__ + "images/link-box-0f29af5e.svg";